export const Pending = "Pending"
export const Success = "Succeed"
export const Failed = "Failed"
export const Refund = "Refund"